import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PromoLineDetail } from './promo-line-detail.entity';
import { PromoProductFamily } from './promo-product-family.entity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';



export class PromoLine extends BaseEntity {
  
  name                    : string;
  paiedBasedOnProduct     : boolean;
  freeBasedOnProduct      : boolean;
  paiedPromoProductFamily : PromoProductFamily = new PromoProductFamily();
  freePromoProductFamily  : PromoProductFamily = new PromoProductFamily();
  paiedProduct            : Product = new Product();
  freeProduct             : Product = new Product();

  promoType               : number;
 

  promoLinesDetail        : PromoLineDetail[] = [];

    constructor() {
      super()
    }
}
